import Stack from '@mui/material/Stack';
import React from 'react';

import { AppBar } from '@/components/layout/AppBar/AppBar';
import { AppFooter } from '@/components/layout/AppFooter/AppFooter';
import { withGoogleAnalytics } from '@/components/layout/withGoogleAnalytics';

interface AppContentProps {
  content: React.JSX.Element | null;
}

const AppLayoutComponent: React.FC<AppContentProps> = ({ content }) => (
  <Stack
    spacing={0}
    sx={{
      minHeight: '98vh',
    }}
  >
    <AppBar />
    {content}
    <AppFooter />
  </Stack>
);

export const AppLayout = withGoogleAnalytics(AppLayoutComponent);
